import React from 'react'

function Container({ children }) {
  return (
    <div className="max-w-full mx-auto px-5 py-3">
      {children}
    </div>
  )
}

export default Container